/* eslint-disable camelcase */
import i18next from 'i18next';

import { ROLES } from '#constants/users';
import { SUBSCRIPTION_PLANS, SUBSCRIPTION_VARIANTS } from '#constants/subscriptions';

const { BASIC, PREMIUM } = SUBSCRIPTION_PLANS;
const { MONTHLY, ANNUAL } = SUBSCRIPTION_VARIANTS;

i18next.addResources('es', 'PlatformAdmin', {
  title: 'SEGUIMIENTO DE VENTAS',
  subtitle: 'Usuarios activos y pagos de la plataforma',
  workspaces: 'Espacios de trabajo',
  users: 'Usuarios',
  payments: 'Pagos',
  retry: 'Reintentar',
  error: 'No pudimos cargar la información. Intente nuevamente.',
  unauthorizedTitle: 'Acceso restringido',
  unauthorized: 'Tu usuario no tiene permisos para ver esta sección.',
  clearFilters: 'Limpiar filtros',
  export: 'Descargar',
  filterStatusAll: 'Estado: todos',
  filterPlanAll: 'Plan: todos',
  filterRoleAll: 'Rol: todos',
  filterPendingAll: 'Pago pendiente: todos',
  filterSourceAll: 'Origen: todos',
  filterNoPlan: 'Sin plan',
  filterYes: 'Con pago pendiente',
  filterNo: 'Sin pago pendiente',
  showingCount: '{{shown}} de {{total}}',
  searchWorkspaces: 'Buscar por espacio, dueño o email',
  searchUsers: 'Buscar por nombre, email o espacio',
  searchPayments: 'Buscar por espacio, pagador o plan',
  // Resumen
  totalWorkspaces: 'Espacios de trabajo',
  totalUsers: 'Usuarios',
  onFreeTrial: 'En prueba gratuita',
  withPlan: 'Con plan contratado',
  collected: 'Total cobrado',
  pendingPayments: 'Pagos pendientes',
  approvedPayments: 'Pagos aprobados',
  contractedSeats: 'Asientos vendidos',
  manualSales: 'Ventas manuales',
  // Columnas
  workspace: 'Espacio',
  owner: 'Dueño',
  email: 'Email',
  createdAt: 'Fecha de alta',
  status: 'Estado',
  plan: 'Plan',
  seatPackage: 'Paquete',
  source: 'Origen',
  membersCount: 'Miembros',
  pending: 'Pago pendiente',
  lastLogin: 'Última conexión',
  role: 'Rol',
  user: 'Usuario',
  date: 'Fecha',
  payer: 'Pagador',
  amount: 'Monto',
  paymentMethod: 'Medio de pago',
  debitDate: 'Fecha de débito',
  scheduledPayments: 'Pagos pendientes y reintentos',
  freeTrialEnd: 'Fin de prueba gratuita',
  nextPayment: 'Próximo cobro',
  lastCharged: 'Último cobro',
  lastChargedAmount: 'Monto último cobro',
  monthlyAmount: 'Monto mensual',
  seatsColumn: 'Asientos contratados',
  extraSeatsColumn: 'Asientos extra',
  statusDetail: 'Detalle',
  mercadoPagoId: 'ID MercadoPago',
  endDate: 'Vigente hasta',
  notes: 'Notas',
  // Valores
  freeTrialUntil: 'Hasta',
  yes: 'Sí',
  no: 'No',
  noPlan: 'Sin plan',
  seats: '{{count}} usuarios',
  seatsWithExtra: '{{seats}} usuarios ({{base}} + {{extra}})',
  [`plan_${BASIC}`]: 'Básico',
  [`plan_${PREMIUM}`]: 'Premium',
  [`period_${MONTHLY}`]: 'Mensual',
  [`period_${ANNUAL}`]: 'Anual',
  source_mercadoPago: 'MercadoPago',
  source_manual: 'Venta manual',
  [`role_${ROLES.OWNER}`]: 'Dueño',
  [`role_${ROLES.ADMIN}`]: 'Administrador',
  [`role_${ROLES.LAWYER}`]: 'Colaborador',
  // Estados de suscripción y pago
  status_freeTrial: 'Prueba gratuita',
  status_pending: 'Pendiente',
  status_authorized: 'Activa',
  status_cancelled: 'Cancelada',
  status_paused: 'Pausada',
  payment_approved: 'Aprobado',
  payment_pending: 'Pendiente',
  payment_authorized: 'Autorizado',
  payment_in_process: 'En proceso',
  payment_in_mediation: 'En mediación',
  payment_rejected: 'Rechazado',
  payment_cancelled: 'Cancelado',
  payment_refunded: 'Devuelto',
  payment_charged_back: 'Contracargo',
  payment_scheduled: 'Programado',
  payment_recycling: 'Reintentando',
  payment_processed: 'Procesado'
});
